export default "__VITE_ASSET__CJn8TmYq__"